/**
 * Simple Creator Hook - Clean integration with creator dashboard
 */

import { useState, useEffect, useCallback } from 'react';
import { fetchVisibleCreators } from '../services/simpleCreatorService';

export const useSimpleCreators = () => {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCreators = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      await fetchVisibleCreators(
        (creatorsData) => {
          setCreators(creatorsData);
          setLoading(false);
        },
        (error) => {
          setError(error.message);
          setLoading(false);
        }
      );
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, []);

  // Load creators on mount
  useEffect(() => {
    loadCreators();
  }, [loadCreators]);

  // Refresh function
  const refresh = useCallback(() => {
    loadCreators();
  }, [loadCreators]);

  return {
    creators,
    loading,
    error,
    refresh
  };
};
